@if(!isDSP){
<app-card-table [metaData]="this.metaDataProviders" [title]="'Gestión de Prestadores'"
    (page)="onPaginatorEvent($event)">
    <div controlButtons class="flex-row layout-gap-15px">
        <button mat-mini-fab matTooltip="Dar alta a prestador" class="mat-elevation-z2" color="primary"
            aria-label="Add icon" (click)="this.openAddProviderDialog()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div class="mts-3" filterInputs class="flex-80 flex-row">
        <div class="flex-70 flex-row align-center-center">
            <app-text-searching-input class="flex-70" [leftIconClass]="'text-primary'" [leftIcon]="'search'"
                [placeholder]="'Búsqueda rápida'" [label]="'Ingrese el nombre del Prestador'"
                [inputFilterValue]="this.inputFilterValue" (onSearch)="
                    this.inputFilterValue = $event; this.onSearch($event)
                ">
            </app-text-searching-input>
        </div>
        <div class="flex-30 flex-align-center">
            <mat-checkbox (change)="onChangeCheckbox($event)" [checked]="true">Activos
            </mat-checkbox>
        </div>
    </div>

    <div table class="mxs-4">
        <div class="flex-100 example-loading-shade" *ngIf="this.isLoadingGettingProviders">
            <app-spinner></app-spinner>
        </div>
        <div class="flex-100 mts-3" *ngIf="this.dataSource?.data?.length > 0; else noProvidersTemplate">
            <table mat-table class="flex-100" [dataSource]="dataSource">
                <!-- id Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>Id</th>
                    <td mat-cell *matCellDef="let provider" style="cursor: pointer;">
                        {{ !!provider.id ? provider.id : "No disponible" }}
                    </td>
                </ng-container>
                <!-- name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let provider" matTooltip="{{
                            provider?.surname || provider?.name
                                ? provider?.surname + ' ' + provider.name
                                : 'Sin nombre'
                        }}">
                        {{
                        provider?.surname || provider?.name
                        ? this.generalService.getSummarizeString(
                        provider?.surname + " " + provider.name,
                        20
                        )
                        : "Sin nombre"
                        }}
                    </td>
                </ng-container>
                <!-- CUIT Column -->
                <ng-container matColumnDef="cuit">
                    <th mat-header-cell *matHeaderCellDef>Cuit</th>
                    <td mat-cell *matCellDef="let provider">
                        {{ !!provider.cuit ? provider.cuit : "Sin Cuit" }}
                    </td>
                </ng-container>
                <!-- MobilePhone Column -->
                <ng-container matColumnDef="mobilePhoneNumber">
                    <th mat-header-cell *matHeaderCellDef>Teléfono</th>
                    <td mat-cell *matCellDef="let provider">
                        {{
                        !!provider.mobilePhoneNumber
                        ? provider.mobilePhoneNumber
                        : "Sin Teléfono"
                        }}
                    </td>
                </ng-container>
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let provider">
                        <span matTooltip="{{
                                !!provider.email ? provider.email : 'Sin email'
                            }}">
                            {{
                            !!provider.email
                            ? this.generalService.getSummarizeString(
                            provider.email,
                            25
                            )
                            : "Sin Email"
                            }}
                        </span>
                    </td>
                </ng-container>
                <!-- Address Column -->
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>Dirección</th>
                    <td mat-cell *matCellDef="let provider">
                        <div class="address-container">
                            <a [href]="this.getLinkMap(provider)" style="text-decoration: none" class="address-link"
                                target="blank">
                                <mat-icon *ngIf="
                                        !!provider.address &&
                                        !!provider.address.street
                                    " class="mat-icon-medium mrs-1">where_to_vote</mat-icon>
                                <span matTooltip="{{
                                        !!provider.address
                                            ? this.patientsService
                                                  .getAddress(provider.address)
                                                  .withAll()
                                            : 'Sin dirección'
                                    }}">
                                    {{
                                    !!provider.address &&
                                    !!provider.address.street
                                    ? this.generalService.getSummarizeString(
                                    this.patientsService
                                    .getAddress(
                                    provider.address
                                    )
                                    .withAll(),
                                    30
                                    )
                                    : "Sin dirección"
                                    }}
                                </span>
                            </a>
                        </div>
                    </td>
                </ng-container>
                <!-- active Column -->
                <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef>Activo</th>
                    <td mat-cell *matCellDef="let provider">
                        <mat-icon class="text-primary" *ngIf="provider.active">check</mat-icon>
                        <mat-icon class="text-primary" *ngIf="!provider.active">clear</mat-icon>
                    </td>
                </ng-container>

                <!-- User Column -->
                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef>Cuenta</th>
                    <td mat-cell *matCellDef="let provider">
                        <!-- Entidad sin usuario  -->
                        <button *ngIf="!provider?.user; else activeUser" style="cursor: auto !important;"
                            matTooltip="Usuario sin cuenta. Presione para crearle una nueva cuenta"
                            (click)="onClickCreateUser(provider)" mat-icon-button>
                            <mat-icon class="text-primary">person_add</mat-icon>
                        </button>
                        <!-- Usuario activo  -->
                        <ng-template #activeUser>
                            <button *ngIf="
                                    provider.user?.active;
                                    else requestedUser
                                " matTooltip="Usuario activo. Presione para desactivarlo"
                                (click)="onClickDeactivateUser(provider)" mat-icon-button>
                                <mat-icon class="text-primary">verified_user</mat-icon>
                            </button>
                        </ng-template>

                        <!-- Usuario con solicitud de activación aún no creado -> Reenviar mail -->
                        <ng-template #requestedUser>
                            <button *ngIf="
                                    !!provider.user?.lastRequestedTimeStamp &&
                                        !provider.user?.createdTimeStamp;
                                    else userDisabled
                                " matTooltip="Mail de activación enviado. Presione para reenviar el mail"
                                (click)="onClickResendEmailUser(provider)" mat-icon-button>
                                <mat-icon class="text-primary">send</mat-icon>
                            </button>
                        </ng-template>

                        <!-- Usuario deshabilitado -->
                        <ng-template #userDisabled>
                            <button matTooltip="Usuario deshabilitado. Presione para activar su cuenta"
                                (click)="onClickActivateUser(provider)" mat-icon-button>
                                <mat-icon class="text-primary">person_off</mat-icon>
                            </button>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- ExchangeStatusState Column -->
                <ng-container matColumnDef="exchangeStatus">
                    <th mat-header-cell *matHeaderCellDef> Estado de Integración </th>
                    <td mat-cell *matCellDef="let provider">
                        <div class="inner-cell inner-cell-auth">
                            <mat-chip-listbox>
                                <mat-chip class="nowrap-pointer"
                                    [ngClass]="this.generalService.getColorExchangeStatus(provider.exchangeStatus)">
                                    <span class="mat-small">
                                        {{
                                        !!provider.exchangeStatus?this.generalService.getExchangeStatusLabel(provider.exchangeStatus)
                                        : 'SIN DATOS' }}
                                    </span>
                                </mat-chip>
                            </mat-chip-listbox>
                        </div>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="border-none-important"></th>
                    <td mat-cell *matCellDef="let provider" class="border-none-important">
                        <div class="inner-cell">
                            <button mat-icon-button (click)="$event.stopPropagation();" matTooltip="Acciones">
                                <mat-icon class="cursor-pointer text-secondary" [matMenuTriggerFor]="menuActions"
                                    [matMenuTriggerData]="{ provider:provider }"
                                    [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
                            </button>
                        </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="bg-on-hover parentShowOnHover" *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
</app-card-table>

<mat-menu #menuActions="matMenu">
    <ng-template matMenuContent let-provider="provider">
        <button mat-menu-item (click)="this.openModifyProviderDialog(provider)"
            *ngIf="provider.active || !updatingProvider"> Editar </button>

    </ng-template>
</mat-menu>


<ng-template #noProvidersTemplate>
    <span class="flex-100 align-center-start text-secondary mts-4" *ngIf="this.dataSource?.data?.length == 0">
        No se encontraron prestadores con los filtros establecidos
    </span>
</ng-template>
}
<!-- ADD or UPD provider -->
<ng-template #addOrModifyProviderTemplate>
    <div class="flex-column" [class.ro-allow]="isDSP"
        style="max-height: calc(100vh - 160px); overflow: auto; padding-right: 20px; scrollbar-gutter: stable both-edges;">
        <div class="flex-100 example-loading-shade"
            *ngIf="this.isLoadingCreatingProviders || this.isLoadingUpdatingProviders">
            <app-spinner></app-spinner>
        </div>
        <form *ngIf="this.formAddOrModifyProvider" [formGroup]="this.formAddOrModifyProvider" class="flex-column"
            (ngSubmit)="onClickCreateOrModifyProvider()">
            <!-- FILES --PROFILE-- & --DOCUMENT-- -->
            <div class="flex-row flex-wrap mbs-2" style="gap: 2%;">

                <!-- PROFILE -->
                <div class="flex-column flex-1-1-auto align-center-center border-radius gap-0-5em bg-primary-lighter"
                    style="min-width: 30% !important; padding: 1rem 2%;">
                    <div class="flex-row align-start-center">
                        <span class="mbs-1 text-primary-darker">
                            <b>Foto/Logo del prestador</b>
                        </span>
                    </div>

                    <!-- Área de contenidos con altura reservada y padding simétrico -->
                    <div class="flex-row align-start-center mls-1 gap-2em pts-1 pbs-1" style="min-height: 90px;">
                        <input #profileInputRef type="file" style="opacity: 0; position: absolute; left: -9999px;"
                            accept=".jpg,.jpeg,.png,.pdf" (change)="addFile($event, entitiesFiles.PROFILE_PHOTO)" />

                        @if(formAddOrModifyProvider.get(this.PROFILE_MEDIA).value !== null){
                        <div class="flex-50 pts-1" style="min-width: max-content !important; min-height: 60px;">
                            <button type="button" class="file-item flex-row align-center-center upload"
                                style="gap: 10px;">
                                @if(formAddOrModifyProvider.get(this.PROFILE_MEDIA).value.fileUrl === null){
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line  bg-secondary-lighter"
                                    style="border-radius: 0.5em; width: 18rem; font-weight: 300; font-size: 12px;">
                                    Archivo
                                    <mat-icon [svgIcon]="'download-primary'" class="mat-icon-medium-px"
                                        [class.ro-allow]="isDSP"
                                        (click)="downloadMedia($event, formAddOrModifyProvider.get(this.PROFILE_MEDIA).value, entitiesFiles.PROFILE_PHOTO)"
                                        matTooltip="Descargar">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.PROFILE_PHOTO,0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                                }@else{
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line"
                                    style="background-color: rgb(244, 240, 240); border-radius: 0.5em; width: 15rem; font-weight: 300; font-size: 12px;">
                                    {{shortenFilename(formAddOrModifyProvider.get(this.PROFILE_MEDIA).value.fileName)}}
                                    <mat-icon class="mat-icon-medium-px"
                                        (click)="previewMedia($event, formAddOrModifyProvider.get(this.PROFILE_MEDIA).value.fileUrl)"
                                        [svgIcon]="'eye-primary'" matTooltip="Vista previa">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.PROFILE_PHOTO,0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                                }
                            </button>
                        </div>
                        }@else{
                        <div class="flex-50 pts-1" style="min-width: max-content !important; min-height: 60px;">
                            <button type="button"
                                class="flex-row flex-100 upload align-center-center cursor-pointer bg-primary-lighter"
                                (click)="openLicenseDialog($event, profileInputRef)"
                                [disabled]="formAddOrModifyProvider.get(this.PROFILE_MEDIA).value?.length == 3">
                                @if(isDSP){
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Xcircle'" [style.color]="'#5734A3'"></mat-icon>
                                    <p class="text-primary flex-100" style="font-weight: 300;">No hay imagen</p>
                                }@else{
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Upload-primary'"></mat-icon>
                                    <p class="text-primary flex-100"><u style="font-weight: 300;">Cargar una foto</u></p>
                                }
                            </button>
                        </div>
                        }
                    </div>
                </div>

                <!-- DOCUMENT -->
                <div class="flex-column flex-1-1-auto align-center-center border-radius gap-0-5em"
                    [ngClass]="isDSP ? 'bg-primary-lighter' : ''" style="border: 5px solid #F2EFF8; padding: 1rem 2%;">
                    <div class="flex-row align-start-center">
                        <span class="mbs-1 text-primary-darker">
                            <b>DNI del prestador</b>
                        </span>
                    </div>

                    <!-- Área de contenidos con altura reservada y padding simétrico -->
                    <div class="flex-row align-start-center mls-1 gap-2em pts-1 pbs-1" style="min-height: 90px;">
                        <!-- Frente -->
                        <div class="flex-50 pts-1" style="min-width: max-content !important; min-height: 60px;">
                            @if(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_FRONT).value !== null){
                            @if(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_FRONT).value.fileUrl === null){
                            <button type="button" class="file-item flex-row align-center-center upload"
                                style="gap: 10px;">
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line  bg-secondary-lighter"
                                    style="border-radius: 0.5em; width: 15rem; font-weight: 300; font-size: 12px;">
                                    Ver Frente del dni
                                    <mat-icon class="mat-icon-medium-px" [class.ro-allow]="isDSP"
                                        [svgIcon]="'download-primary'"
                                        (click)="downloadMedia($event, formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_FRONT).value, entitiesFiles.DOCUMENT_FRONT)"
                                        matTooltip="Descargar">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.DOCUMENT_FRONT,0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                            </button>
                            }@else{
                            <button type="button" class="file-item flex-row align-center-center upload"
                                style="gap: 10px;">
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line  bg-secondary-lighter"
                                    style="border-radius: 0.5em; width: 15rem; font-weight: 300; font-size: 12px;">
                                    {{shortenFilename(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_FRONT).value.fileName)}}
                                    <mat-icon class="mat-icon-medium-px"
                                        (click)="previewMedia($event, formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_FRONT).value.fileUrl)"
                                        [svgIcon]="'eye-primary'" matTooltip="Vista previa">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.DOCUMENT_FRONT,0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                            </button>
                            }
                            }@else{
                            <input #documentFrontInputRef type="file"
                                style="opacity: 0; position: absolute; left: -9999px;" accept=".jpg,.jpeg,.png,.pdf"
                                (change)="addFile($event, entitiesFiles.DOCUMENT_FRONT)" />
                            <button type="button" class="flex-row flex-100 upload align-center-center cursor-pointer"
                                [ngClass]="isDSP ? 'bg-primary-lighter' : ''"
                                (click)="openDocumentBackDialog($event, documentFrontInputRef)">
                                @if(isDSP){
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Xcircle'" [style.color]="'#5734A3'"></mat-icon>
                                    <p class="text-primary flex-100" style="font-weight: 300;">No hay imagen</p>
                                }@else{
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Upload-primary'"></mat-icon>
                                    <p class="text-primary flex-100"><u style="font-weight: 300;">Cargar Frente del dni</u></p>
                                }
                            </button>
                            }
                        </div>

                        <!-- Dorso -->
                        <div class="flex-50 pts-1" style="min-width: max-content !important; min-height: 60px;">
                            @if(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_BACK).value !== null){
                            @if(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_BACK).value.fileUrl === null){
                            <button type="button" class="file-item flex-row align-center-center upload"
                                style="gap: 10px;">
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line  bg-secondary-lighter"
                                    style="border-radius: 0.5em; width: 15rem; font-weight: 300; font-size: 12px;">
                                    Ver dorso del dni
                                    <mat-icon class="mat-icon-medium-px" [class.ro-allow]="isDSP"
                                        [svgIcon]="'download-primary'"
                                        (click)="downloadMedia($event, formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_BACK).value, entitiesFiles.DOCUMENT_BACK)"
                                        matTooltip="Descargar">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.DOCUMENT_BACK, 0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                            </button>
                            }@else{
                            <button type="button" class="file-item flex-row align-center-center upload"
                                style="gap: 10px;">
                                <span
                                    class="flex-100 row-wrap cursor-pointer align-center-center gap-0-5em p-3 hold-one-line bg-secondary-lighter"
                                    style="border-radius: 0.5em; width: 15rem; font-weight: 300; font-size: 12px; ">
                                    {{shortenFilename(formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_BACK).value.fileName)}}
                                    <mat-icon class="mat-icon-medium-px"
                                        (click)="previewMedia($event, formAddOrModifyProvider.get(this.DOCUMENT_MEDIA_BACK).value.fileUrl)"
                                        [svgIcon]="'eye-primary'" matTooltip="Vista previa">
                                    </mat-icon>
                                    <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                        (click)="onPressDeleteFile($event, entitiesFiles.DOCUMENT_BACK,0)"
                                        class="mat-icon-medium-px" [svgIcon]="'Delete-enabled-primary-22x22'"
                                        style="cursor: pointer">
                                    </mat-icon>
                                </span>
                            </button>
                            }
                            }@else{
                            <input #documentBackInputRef type="file"
                                style="opacity: 0; position: absolute; left: -9999px;" accept=".jpg,.jpeg,.png,.pdf" e
                                (change)="addFile($event, entitiesFiles.DOCUMENT_BACK)" />
                            <button type="button" class="flex-row flex-100 upload align-center-center cursor-pointer"
                                [ngClass]="isDSP ? 'bg-primary-lighter' : ''"
                                (click)="openDocumentBackDialog($event, documentBackInputRef)">
                                @if(isDSP){
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Xcircle'" [style.color]="'#5734A3'"></mat-icon>
                                    <p class="text-primary flex-100" style="font-weight: 300;">No hay imagen</p>
                                }@else{
                                    <mat-icon class="mat-icon-medium-px" [svgIcon]="'Upload-primary'"></mat-icon>
                                    <p class="text-primary flex-100"><u style="font-weight: 300;">Cargar dorso del dni</u></p>
                                }
                            </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <!-- Provider NAME AND SURNAME -->
            <div class="flex-row flex-wrap layout-gap-25px align-space-between-center">
                <!-- Provider NAME -->
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">
                        Nombre del prestador *
                    </span>
                    <app-text-input [name]="this.NAME" [form]="this.formAddOrModifyProvider">
                    </app-text-input>
                </div>
                <!-- Provider SURNAME -->
                <div class="flex-column flex-1-1-auto">
                    <span class="subtitle-3 text-primary-darker">
                        Apellido *
                    </span>
                    <app-text-input [name]="this.SURNAME" [form]="this.formAddOrModifyProvider">
                    </app-text-input>
                </div>
            </div>

            <div class="flex-row flex-wrap full-width gap-2em">
                <!-- Provider EMAIL -->
                <div class="flex-column flex-30">
                    <span class="subtitle-3 text-primary-darker"> Email </span>
                    <app-text-input [name]="this.EMAIL" [form]="this.formAddOrModifyProvider">
                    </app-text-input>
                </div>

                <!-- Provider CUIT -->
                <div class="flex-column flex-1-1-auto">
                    <span class="subtitle-3 text-primary-darker"> CUIT * </span>
                    <app-number-input [name]="this.CUIT" [form]="this.formAddOrModifyProvider"
                        [placeholder]="'Ingrese solo números (sin /, \\, -, *)'">
                    </app-number-input>
                </div>

                <!-- Provider BIRTHDAY -->
                <div class="flex-column flex-20">
                    <span class="subtitle-3 text-primary-darker">
                        Fecha de nacimiento
                    </span>
                    <app-date-picker [name]="this.BIRTHDATE" [form]="formAddOrModifyProvider">
                    </app-date-picker>
                </div>

                <!-- Provider PHONE NUMBER-->
                <div class="flex-column flex-18">
                    <span class="subtitle-3 text-primary-darker">
                        Número de teléfono
                    </span>
                    <app-text-input [name]="this.MOBILE_PHONENUMBER" [form]="this.formAddOrModifyProvider">
                    </app-text-input>
                </div>

            </div>

            <div class="flex-row flex-wrap layout-gap-25px align-space-between-center">
                <!-- Provider COUNTRY -->
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">
                        Nacionalidad
                    </span>
                    <app-select-searching-dynamic-input [defaultValue]="this.actualProviderNationality"
                        [elements]="this.nationalitiesOnSelect" [name]="this.NATIONALITY"
                        [nameSearching]="this.NATIONALITY_SEARCHING" [form]="this.formAddOrModifyProvider"
                        [calculateName]="this.calculateNameNationality" [placeholderNoValue]="'Sin resultados'"
                        [placeholderSearching]="'Ingrese nacionalidad...'" [httpGet]="this.loadNationalitiesByName">
                    </app-select-searching-dynamic-input>
                </div>
                <!-- Provider LOCATION -->
                <div class="flex-column flex-1-1-auto">
                    <span class="subtitle-3 text-primary-darker">
                        Localidad *
                    </span>
                    <app-select-searching-dynamic-input class="flex-1-1-auto"
                        [defaultValue]="this.actualProviderLocation" [elements]="this.locationsOnSelect"
                        [name]="this.ADDRESS_LOCATION" [nameSearching]="this.ADDRESS_LOCATION_SEARCHING"
                        [form]="getAddressFormGroup()" [calculateName]="this.calculateNameLocation"
                        [placeholderNoValue]="'Sin resultados'" [placeholderSearching]="'Ingrese localidad...'"
                        [httpGet]="this.loadLocationsByName" (selectedWithEntity)="onSelectCity($event)">
                    </app-select-searching-dynamic-input>
                </div>
            </div>

            <!-- Provider ADDRESS -->
            <div class="flex-row gap-2em" [formGroupName]="this.ADDRESS">
                <div class="flex-60">
                    <span class="subtitle-3 text-primary-darker mbs-1">
                        Calle y Nº *
                    </span>
                    <app-address-input [name]="this.ADDRESS_STREET" [address]="addressInputModel"
                        [city]="providerAddress.city || actualProvider?.address?.location?.name"
                        [province]="providerAddress.province || actualProvider?.address?.location?.province?.name"
                        [form]="getAddressFormGroup()" (selected)="onSelectAddress($event)"
                        (addressWithoutNumber)="onConfirmWithoutAddress($event)"
                        [getCheckState]="actualProvider?.address?.withoutNumber">
                    </app-address-input>
                </div>

                <div class="flex-20">
                    <span class="subtitle-3 text-primary-darker">
                        Piso
                    </span>
                    <app-text-input [name]="this.ADDRESS_FLOOR" [form]="getAddressFormGroup()">
                    </app-text-input>
                </div>

                <div class="flex-20">
                    <!-- Number -->
                    <!-- <div class="flex-column">
                        <span class="subtitle-3 text-primary-darker">
                            Altura *
                        </span>
                        <app-number-input [name]="this.ADDRESS_STREETNUMBER" [form]="getAddressFormGroup()">
                        </app-number-input>
                    </div> -->
                    <!-- Dpto -->
                    <!-- <div class="flex-column"> -->
                    <span class="subtitle-3 text-primary-darker">
                        Departamento
                    </span>
                    <app-text-input [name]="this.ADDRESS_FLAT" [form]="getAddressFormGroup()">
                    </app-text-input>
                    <!-- </div> -->
                </div>
            </div>

            <!-- Address extra -->
            <div class="flex-column">
                <span class="subtitle-3 text-primary-darker">
                    Observaciones de la dirección
                </span>
                <div class="flex-row align-space-around">
                    <app-text-input class="flex-100" [name]="this.ADDRESS_FLATEXTRA" [form]="getAddressFormGroup()" [maxLength]="ADDRESS_FLATEXTRA_MAX_LENGTH">
                    </app-text-input>
                </div>
            </div>

            <!-- Coverage region / Área de cobertura -->
            <div class="line-separator line-separator-center-left mys-4 align-center-center">
                <div class="mx-2 align-center-center">
                    <span class="text-primary">Área de cobertura</span>
                </div>
            </div>
            <div class="flex-row align-space-between-center" [formArrayName]="this.PROVIDER_LOCATIONS" *ngFor="
                        let provLoc of this.providerLocationsFormArray['controls'];
                        let j = index
                    ">
                <div class="flex-100" [formGroupName]="j">
                    <div class="flex-row align-center">
                        <!-- Location -->
                        <div class="flex-column flex-1-1-auto">
                            <span class="subtitle-3 text-primary-darker">
                                Localidad
                            </span>
                            <app-select-searching-dynamic-input class="flex-1-1-auto" [form]="
                                        this.providerLocationsFormArray['controls'][
                                            j
                                        ]['controls']['location']
                                    " [defaultValue]="
                                        this.actualProviderExtraLocations[j]
                                    " [elements]="this.extraLocationsOnSelect[j]" [name]="this.EXTRA_LOCATION_ID"
                                [nameSearching]="this.EXTRA_LOCATION_SEARCHING" [placeholderNoValue]="'Sin resultados'"
                                [placeholderSearching]="'Ingrese localidad...'" [httpGet]="this.loadLocationsByName"
                                [calculateName]="
                                        this.calculateNameExtraLocation
                                    " [calculateId]="this.calculateIdExtraLocation">
                            </app-select-searching-dynamic-input>
                        </div>
                        <!-- BUTTONS -->
                        <!-- Remove -->
                        <div class="actions-container pls-2" [class.display-none]="isDSP">
                            <button class="btn" [disabled]="providerLocationsFormArray['controls'].length < 2"
                                (click)="removeProviderLocation(j)">
                                <mat-icon matTooltip="Remover localidad" svgIcon="trash-circle-primary"
                                    class="actions-btns"></mat-icon>
                            </button>

                            <button matTooltip="Agregar localidad" mat-icon-button
                                *ngIf="providerLocationsFormArray['controls'].length - 1 == j" [color]="'primary'"
                                type="button" (click)="addProviderLocation()" [disabled]="
                                    providerLocationsFormArray['controls'][j]['controls']['location']['value']['id'] == null
                                  ">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Información Academica -->
            <div class="line-separator line-separator-center-left mys-2 align-center-center">
                <div class="mx-2 align-center-center">
                    <span class="text-primary">Información Académica</span>
                </div>
            </div>

            <div class="flex-100">
                <input #titleInputRef type="file" multiple style="opacity: 0; position: absolute; left: -9999px"
                    accept=".jpg,.jpeg,.png,.pdf" (change)="addFile($event, entitiesFiles.TITLE)" />
                <!-- ADD TITLE -->
                <div class="flex-row cursor-pointer"
                    [ngClass]="formAddOrModifyProvider.get(PROVIDER_TITLE).value.length === 5 ? 'btnDisabled' : ''">
                    <div [class.display-none]="isDSP">
                        <button type="button"
                            [disabled]="formAddOrModifyProvider.get(this.PROVIDER_TITLE).value.length == 5"
                            class="flex-row align-center-center upload cursor-pointer gap-0-5em"
                            (click)="openTitleDialog($event, titleInputRef)">
                            <mat-icon class="mat-icon-medium-px" [svgIcon]="'Upload-primary'"></mat-icon>
                            <p class="text-primary" style="font-weight: 300;">
                                <u>{{formAddOrModifyProvider.get(this.PROVIDER_TITLE).value.length > 0 ? 'Agregar Archivo/s' : 'Agregar Título/s' }}</u>
                            </p>
                        </button>
                    </div>
                </div>
                <!-- VIEW FILES -->
                <!-- Post Mode -->
                @if(formAddOrModifyProvider.get(this.PROVIDER_TITLE).value.length > 0){
                <div class="mts-2">
                    <div class="row-wrap gap-2em" style="display: flex;">
                        <div *ngFor="let file of formAddOrModifyProvider.get(this.PROVIDER_TITLE).value;let i = index"
                            class="file-item align-center-center" style="flex-wrap: wrap !important;">
                            @if(file.fileUrl === null){
                            <button type="button" class="file-item upload full-width">
                                <span class="flex-row align-center-center gap-0-5em p-3 full-width"
                                    style="background-color: rgb(244, 240, 240); border-radius: 0.5em;font-weight: 300;">
                                    Archivo_{{i}}
                                    <span class="flex-row align-center-center gap-0-5em">
                                        <mat-icon [svgIcon]="'download-primary'"
                                            class="mat-icon-medium-px cursor-pointer"
                                            (click)="downloadMedia($event, file, entitiesFiles.TITLE)"
                                            [class.ro-allow]="isDSP" matTooltip="Descargar">
                                        </mat-icon>
                                        <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                            (click)="onPressDeleteFile($event, entitiesFiles.TITLE, i)"
                                            [svgIcon]="'Delete-enabled-primary-22x22'"
                                            class="mat-icon-medium-px cursor-pointer">
                                        </mat-icon>
                                    </span>
                                </span>
                            </button>
                            }@else {
                            <button type="button" class="file-item upload full-width">
                                <span class="flex-row align-center-center gap-0-5em p-3 full-width"
                                    style="background-color: rgb(244, 240, 240); border-radius: 0.5em; font-weight: 300; font-size: 12px;">
                                    {{shortenFilename(file.fileName)}}
                                    <span class="flex-row align-center-center gap-0-5em">
                                        <mat-icon class="mat-icon-medium-px cursor-pointer"
                                            (click)="previewMedia($event, file.fileUrl)" [svgIcon]="'eye-primary'"
                                            matTooltip="Vista previa">
                                        </mat-icon>
                                        <mat-icon matTooltip="Eliminar" [class.display-none]="isDSP"
                                            (click)="onPressDeleteFile($event, entitiesFiles.TITLE, i)"
                                            [svgIcon]="'Delete-enabled-primary-22x22'"
                                            class="mat-icon-medium-px cursor-pointer">
                                        </mat-icon>
                                    </span>
                                </span>
                            </button>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>

            <!-- Select specialties -->
            <div class="line-separator line-separator-center-left align-center-center mts-2 mbs-2">
                <div class="mx-2 align-center-center">
                    <span class="text-primary">Especialidades</span>
                </div>
            </div>

            <div class="flex-row flex-100  bg-primary-lighter border-radius mys-2" [formArrayName]="this.SPECIALTIES"
                *ngFor=" let specialty of this.specialtiesFormArray['controls'];  let specialtyIndex = index ">
                <div class="flex-column flex-100 full-width p-2" [formGroupName]="specialtyIndex">
                    <div class="flex-row gap-2em flex-wrap">
                        <!-- Specialty -->
                        <div class="flex-column flex-30">
                            <span class="subtitle-3 text-primary-darker">
                                Especialidad *
                            </span>
                            <app-select-searching-dynamic-input class="mb-0 pb-0"
                                [defaultValue]="this.actualProviderSpecialties[specialtyIndex]"
                                [elements]="this.specialtiesOnSelect[specialtyIndex]" [name]="this.SPECIALTIES_ID"
                                [nameSearching]="this.SPECIALTIES_SEARCHING"
                                [form]="getSpecialtiestFormGroup(specialtyIndex)" [placeholderNoValue]="'Sin resultados'"
                                [placeholderSearching]="'Buscar especialidad...'" [httpGet]="this.getSpecialtiesByName"
                                (selected)="this.onSelectSpecialty(specialtyIndex)"
                                [calculateName]="this.calculateNameSpecialty" [calculateId]="this.calculateIdSpecialty"
                                [inputBgColor]="'white'">
                            </app-select-searching-dynamic-input>
                        </div>
                        <!-- Specialty Professional Type -->
                        @if (getSpecialtyProfessionalTypes(specialtyIndex).length > 0) {
                            <div class="flex-column">
                                <span class="subtitle-3 text-primary-darker">
                                    Tipo de profesional
                                </span>

                                <app-select-input [name]="this.SPECIALTY_PROFESSIONAL_TYPE_ID"
                                    [form]="getSpecialtiestFormGroup(specialtyIndex)"
                                    [elements]="getSpecialtyProfessionalTypes(specialtyIndex)"
                                    [calculateId]="this.calculateIdSpecialtyProfessionalType"
                                    [calculateName]="this.calculateNameSpecialtyProfessionalType"
                                    [clearable]="true"
                                    (selected)="onChangeSpecialtyProfessionalType($event, specialtyIndex)">
                                </app-select-input>
                            </div>
                        }
                    </div>
                    <mat-error
                        *ngIf="getSpecialtiestFormGroup(specialtyIndex).hasError('licenseRequired') && getSpecialtiestFormGroup(specialtyIndex).touched">
                        Debe ingresar al menos una matrícula para esta especialidad.
                    </mat-error>

                    <!-- Medical license -->.
                    <div class="flex-column gap-1em">
                        <div class="flex-row pls-4 border-radius align-center-center " [formArrayName]="this.MEDICAL_LICENSES"
                            style="background-color: white;"
                            *ngFor="let medicalLicense of this.getMedicalLicensesFormArray(specialtyIndex)['controls'] let licenseIndex= index">
                            <div [formGroupName]="licenseIndex" class="flex-column flex-100">
                                <div class="flex-row align-space-between-center flex-100">
                                    <input #licenseInputRef type="file" multiple accept=".jpg,.jpeg,.png,.pdf"
                                        style="opacity: 0; position: absolute; left: -9999px"
                                        (change)="addFile($event,entitiesFiles.MEDICAL_LICENSE ,specialtyIndex, licenseIndex)" />

                                    <div class="flex-column pts-2">
                                        <div class="flex-row gap-2em flex-100 align-start-center" style="flex-wrap: wrap;">
                                            <!-- MEDICAL LICENSE -->
                                            <div class="flex-column flex-20">
                                                <span class="subtitle-3 text-primary-darker">
                                                    Matrícula
                                                </span>
                                                <app-text-input [name]="this.MEDICAL_LICENSE_VALUE"
                                                    [form]="getMedicalLicensesTypeFormArray(specialtyIndex,licenseIndex)">
                                                </app-text-input>
                                            </div>
                                            <!-- VALIDITY -->
                                            <div class="flex-column flex-15">
                                                <span class="subtitle-3 text-primary-darker">
                                                    Válida hasta
                                                </span>
                                                <app-date-picker [name]="this.MEDICAL_LICENSE_VALIDITY"
                                                    [form]="getMedicalLicensesTypeFormArray(specialtyIndex,licenseIndex)">
                                                </app-date-picker>
                                            </div>
                                            <!-- TYPE -->
                                            <div class="flex-column flex-15">
                                                <span class="subtitle-3 text-primary-darker">
                                                    Tipo de matrícula
                                                </span>
                                                <app-select-input [name]="this.MEDICAL_LICENSE_TYPE"
                                                    [form]="getMedicalLicensesTypeFormArray(specialtyIndex,licenseIndex)"
                                                    [defaultValue]="!!this.getMedicalLicensesFormArray(specialtyIndex)['controls'][licenseIndex]?.get(MEDICAL_LICENSE_TYPE)?.value?.id
                                                                    ?
                                                                    this.getMedicalLicensesFormArray(specialtyIndex)['controls'][licenseIndex].get(MEDICAL_LICENSE_TYPE).value.id.toString()
                                                                    :
                                                                    ''" [elements]="this.medicalLicensesTypes"
                                                    [calculateId]="this.calculateIdMedicalLicenseType"
                                                    [calculateName]="this.calculateNameMedicalLicenseType"
                                                    (selected)="this.onChangeType($event)">
                                                </app-select-input>
                                            </div>
                                            <!-- Country -->
                                            <div class="flex-column flex-25">
                                                <span class="subtitle-3 text-primary-darker">
                                                    Habilitar en
                                                </span>
                                                <app-select-searching-dynamic-input
                                                    [defaultValue]="this.actualProviderNationality"
                                                    [elements]="this.nationalitiesOnSelect" [name]="this.PROVIDER_RANGE"
                                                    [nameSearching]="this.NATIONALITY_SEARCHING"
                                                    [form]="this.formAddOrModifyProvider"
                                                    [calculateName]="this.calculateNameNationality"
                                                    [placeholderNoValue]="'Sin resultados'"
                                                    [placeholderSearching]="'Ingrese nacionalidad...'"
                                                    [httpGet]="this.loadNationalitiesByName">
                                                </app-select-searching-dynamic-input>
                                            </div>

                                            <!-- Verify License -->
                                            @if( isMedicalLicenseActionsEnabled(specialtyIndex, licenseIndex) || medicalLicense.get(MEDICAL_LICENSE_VALUE).value || medicalLicense.get(MEDICAL_LICENSE_TYPE).value){
                                            <span class="flex subtitle-3 text-primary cursor-pointer " [class.ro-allow]="isDSP"
                                                (click)="onGetSisa(getMedicalLicensesTypeFormArray(specialtyIndex, licenseIndex).get(MEDICAL_LICENSE_VALUE)?.value)">
                                            <mat-icon svgIcon="seal-check" class="actions-btns-small"></mat-icon>
                                            <u class="cursor-pointer " matTooltip="Copiar y verificar SISA" role="link">
                                                Verificar SISA
                                            </u>
                                        </span>
                                        }
                                            <!-- Medical License Actions BTNS -->
                                            <div class="flex-row flex-10 align-center-center"
                                                [class.display-none]="isDSP">

                                                <button class="btn"
                                                    (click)="confirmRemoveMedicalLicense(specialtyIndex, licenseIndex)"
                                                    matTooltip="Remover matrícula">
                                                    <mat-icon svgIcon="trash-circle-primary"
                                                        class="actions-btns"></mat-icon>
                                                </button>

                                                <button class="btn"
                                                    *ngIf="this.getMedicalLicensesFormArray(specialtyIndex)['controls'].length -1 == licenseIndex"
                                                    matTooltip="{{getMedicalLicensesFormArray(specialtyIndex).length == 5 ? 'Máximo alcanzado' : 'Agregar matrícula'}}"
                                                    (click)="this.addMedicalLicense(specialtyIndex)"
                                                    [disabled]="getMedicalLicensesFormArray(specialtyIndex).length == 5 ">
                                                    <mat-icon svgIcon="add-circle-primary"
                                                        class="actions-btns"></mat-icon>
                                                </button>

                                            </div>


                                        </div>
                                        <!-- Expiration  Date -->
                                        @if(!isDSP){
                                        <app-checkbox-input style="transform: translateX(-0.5em);"
                                            [form]="this.getMedicalLicensesTypeFormArray(specialtyIndex, licenseIndex)"
                                            [label]="'Matrícula con fecha de vencimiento'" name="expirationDate">
                                        </app-checkbox-input>
                                        }
                                        <!-- Upload files -->
                                        <div class="flex-row">
                                            <div class="flex-row align-between-center mts-3"
                                                [ngClass]="medicalLicense.get(MEDICAL_LICENSE_MEDIA).value?.length == 3 || !medicalLicense.get(MEDICAL_LICENSE_VALUE).value || !medicalLicense.get(MEDICAL_LICENSE_TYPE).value ? 'btnDisabled' : ''">
                                                <div [class.display-none]="isDSP">
                                                    <button type="button"
                                                        class="flex-row align-center-center upload cursor-pointer"
                                                        (click)="openLicenseDialog($event, licenseInputRef)"
                                                        style="gap: 5px;"
                                                        [disabled]="medicalLicense.get(MEDICAL_LICENSE_MEDIA).value?.length == 3 || !medicalLicense.get(MEDICAL_LICENSE_VALUE).value || !medicalLicense.get(MEDICAL_LICENSE_TYPE).value || !isMedicalLicenseActionsEnabled(specialtyIndex, licenseIndex)">
                                                        <mat-icon class="mat-icon-medium-px"
                                                            [svgIcon]="'Upload-primary'"></mat-icon>
                                                        <p class="text- center text-primary" style="font-weight: 300;">
                                                            <u>{{medicalLicense.get(MEDICAL_LICENSE_MEDIA).value?.length
                                                                > 0 ?
                                                                'Agregar Archivos' : 'Cargar Matrícula'}}</u>
                                                        </p>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>


                                        <!-- VIEW FILES -->
                                        <div class="mts-2">
                                            <div class="flex-100">
                                                <div class="flex-row gap-1em" style="display: flex; flex-wrap: wrap">
                                                    @if (medicalLicense.get(MEDICAL_LICENSE_MEDIA).value?.length > 0 ) {
                                                    <div *ngFor="let licenseFile of medicalLicense.get(MEDICAL_LICENSE_MEDIA).value; let licenseFileIndex = index"
                                                        class="file-item flex-row p-1 align-center-center">
                                                        <!-- local -->
                                                        <button type="button" class="file-item upload full-width"
                                                            style="gap: 10px;">
                                                            @if(licenseFile.fileUrl === null){
                                                            <span
                                                                class="flex-row align-center-center gap-0-5em p-1 full-width"
                                                                style="background-color: rgb(244, 240, 240); border-radius: 0.5em; font-weight: 300;">
                                                                Archivo_{{licenseFileIndex}}
                                                                <span class="flex-row align-center-center gap-0-5em">
                                                                    <mat-icon class="mat-icon-medium-px cursor-pointer"
                                                                        [class.ro-allow]="isDSP"
                                                                        (click)="downloadMedia($event, licenseFile, entitiesFiles.MEDICAL_LICENSE)"
                                                                        [svgIcon]="'download-primary'"
                                                                        matTooltip="Descargar">
                                                                    </mat-icon>
                                                                    <mat-icon matTooltip="Eliminar"
                                                                        [class.display-none]="isDSP"
                                                                        (click)="onPressDeleteFile($event, entitiesFiles.MEDICAL_LICENSE, licenseFileIndex, specialtyIndex, licenseIndex)"
                                                                        [svgIcon]="'Delete-enabled-primary-22x22'"
                                                                        class="mat-icon-medium-px cursor-pointer">
                                                                    </mat-icon>
                                                                </span>
                                                            </span>
                                                            }@else{
                                                            <span
                                                                class="flex-row align-center-center gap-0-5em p-1 full-width"
                                                                style="background-color: rgb(244, 240, 240); border-radius: 0.5em; font-weight: 300;">
                                                                {{shortenFilename(licenseFile.fileName)}}
                                                                <span class="flex-row align-center-center gap-0-5em">
                                                                    <mat-icon class="mat-icon-medium-px cursor-pointer"
                                                                        (click)="previewMedia($event, licenseFile.fileUrl)"
                                                                        [svgIcon]="'eye-primary'"
                                                                        matTooltip="Vista previa">
                                                                    </mat-icon>
                                                                    <mat-icon matTooltip="Eliminar"
                                                                        [class.display-none]="isDSP"
                                                                        (click)="onPressDeleteFile($event, entitiesFiles.MEDICAL_LICENSE, licenseFileIndex, specialtyIndex, licenseIndex)"
                                                                        [svgIcon]="'Delete-enabled-primary-22x22'"
                                                                        class="mat-icon-medium-px cursor-pointer">
                                                                    </mat-icon>
                                                                </span>
                                                            </span>
                                                            }
                                                        </button>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- Specialty Actions BTNS -->
                        </div>
                        <div class="flex-row align-end-center pts-3" [class.display-none]="isDSP">

                            <button type="button" class="btn bg-primary-lighter"
                                [disabled]="specialtiesFormArray['controls'].length < 2"
                                (click)="onClickRemoveSpecialty($event, specialtyIndex)">
                                <mat-icon matTooltip="Remover especialidad"
                                    [svgIcon]="specialtiesFormArray?.length < 2 ? 'trash-circle-disabled' : 'trash-circle-primary'"
                                    class="actions-btns-big">
                                </mat-icon>
                            </button>

                            <button type="button" class="btn  bg-primary-lighter"
                                *ngIf="specialtiesFormArray['controls'].length -1 == specialtyIndex"
                                matTooltip="{{specialtiesFormArray.length == 10 ? 'Máximo alcanzado' : 'Agregar especialidad'}}"
                                (click)="this.addSpecialty()" [disabled]="specialtiesFormArray.length === 10">
                                <mat-icon svgIcon="add-circle-primary" class="actions-btns-big">
                                </mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!--  / -->
            <div class="line-separator line-separator-center-left mys-4 align-center-center">
                <div class="mx-2 align-center-center">
                    <span class="text-primary">Condición del Prestador</span>
                </div>
            </div>

            <div class="row-wrap gap-2em">
                <!-- Provider State -->
                <div class="flex-column flex-25 mts-3">
                    <span class="subtitle-3 text-primary-darker">
                        Estado del prestador *
                    </span>
                    <app-select-input [name]="this.PROVIDER_STATUS" [form]="this.formAddOrModifyProvider"
                        [defaultValue]="!!actualProvider?.status ? actualProvider.status.toString() : '' "
                        [elements]="this.providerStatusArray" [calculateName]="this.calculateNameProviderStatus"
                        [calculateId]="this.calculateIdProviderStatus"
                        (selected)="this.calculateProviderStatus($event)">
                    </app-select-input>
                </div>
                <!-- Provider Observations -->
                <div class="flex-column flex-1-1-auto mts-3">
                    <span class="subtitle-3 text-primary-darker">
                        Observaciones
                    </span>
                    <app-text-input class="flex-100" [name]="this.PROVIDER_OBSERVATIONS" [maxLength]="PROVIDER_OBSERVATIONS_MAX_LENGTH"
                        [form]="this.formAddOrModifyProvider" (change)="onChangeObservation($event)">
                    </app-text-input>
                </div>
            </div>
            <div *ngIf="updatingProvider" class="flex align-end-center" [class.display-none]="isDSP">
                <span class="subtitle-6 text-primary cursor-pointer flex-row align-center-center"
                    (click)="goToProviderSchedule()">
                    <mat-icon matTooltip="Ver actividad" svgIcon="calendar-primary"
                        class="actions-btns-small"></mat-icon>
                    <u>VER ACTIVIDAD</u>
                </span>
            </div>
            <!-- BOTTOM BUTTONS -->
            @if(!isDSP){
            <div class="flex-row align-space-around-start  mts-3">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()">
                    CANCELAR
                </button>
                <button *ngIf="this.addingProvider" mat-flat-button [color]="'primary'" type="submit" [disabled]="!this.formAddOrModifyProvider.valid || this.loadingAddFile || this.isLoadingCreatingProviders ||
                          (!providerWithoutNumberCheck && providerWithoutStreetNumber) ">
                    @if(!isLoadingCreatingProviders){
                    <span> CREAR </span>
                    } @else {
                    <div class="custom-spinner">
                        <div class="spinner-circle"></div>
                    </div>
                    }
                </button>

                <button *ngIf="this.updatingProvider" mat-flat-button [color]="'primary'" type="submit" [disabled]="!this.formAddOrModifyProvider.valid || this.loadingAddFile || this.isLoadingUpdatingProviders ||
                (!providerWithoutNumberCheck && providerWithoutStreetNumber) || !this.formAddOrModifyProvider.dirty">
                    @if(!isLoadingUpdatingProviders){
                    <span> MODIFICAR </span>
                    } @else {
                    <div class="custom-spinner">
                        <div class="spinner-circle"></div>
                    </div>
                    }
                </button>
            </div>
            }@else if (isDSP){
            <div class="flex-row align-center-center mts-3 cursor-pointer">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()" class="cursor-pointer" [class.ro-allow]="isDSP">
                    CERRAR
                </button>
            </div>
            }
        </form>
    </div>
</ng-template>


@if (isDSP) {
<ng-container>
    <div class="app-ro">
        <ng-container *ngIf="dspReady; else dspLoading">
            <ng-container *ngTemplateOutlet="addOrModifyProviderTemplate"></ng-container>
        </ng-container>

        <ng-template #dspLoading>
            <div class="flex align-center-center" style="min-height: 200px">
                <mat-spinner color="primary" diameter="30"></mat-spinner>
            </div>
        </ng-template>
    </div>
</ng-container>
}
